export const resendEmailVerification = gql`
    mutation resendEmailVerification(
        $email: String
    ) {
        resendEmailVerification(
            input:{
                email: $email,
            }) {
            status
        }
    }
`
